import { render, staticRenderFns } from "./Risk.vue?vue&type=template&id=f2d435d8&scoped=true&lang=pug"
import script from "./Risk.vue?vue&type=script&lang=ts"
export * from "./Risk.vue?vue&type=script&lang=ts"
import style0 from "./Risk.vue?vue&type=style&index=0&id=f2d435d8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d435d8",
  null
  
)

/* custom blocks */
import block0 from "./Risk.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fcomponents%2FWidgets%2FHighlights%2FAssessment%2FHighlight%2FRisk.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports